var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"content-main my-md-2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',[_vm._v("UI testing")])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }